import { editTemplatesCheck } from '.';
import LearningCollectionEditStore from '..';
import { LearningCollectionEditFormResource, PreviewingUpdating, Visibility } from '../Types';

const updateCollectionsStoreAndTransitionToPreview = (
  store: LearningCollectionEditStore,
  celebrationPage: Visibility,
  resource: LearningCollectionEditFormResource,
) => {
  editTemplatesCheck(resource).fork(store.templateLoadError, ({ template }) =>
    store.previewing(resource, template, celebrationPage),
  );
};

const previewing =
  (store: LearningCollectionEditStore, state: PreviewingUpdating) =>
  (learningCollectionFormResource: LearningCollectionEditFormResource) => {
    updateCollectionsStoreAndTransitionToPreview(
      store,
      state.celebrationPage,
      learningCollectionFormResource,
    );
    state.iframeContentStore.ready();
  };

export default previewing;
